import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios"; 
import { MyApi } from "./MyApi";
import tripadvisor from "./assets/images/tripadvisor.png"

export default function Footer() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [setting, setSetting] = useState(null);

  /* Scroll to top button */
  useEffect(() => {
    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* Fetch site settings */
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + "site-setting", {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status && res.data.data) {
          setSetting(res.data.data);
        }
      } catch (error) {
        console.error("Failed to load site settings");
      }
    };

    fetchSetting();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="footer_bx">
      <Container>
        <Row>
          {/* Quick Links */}
          <Col lg={5} className="mb-4">
            <h4>Quick Links</h4>
            <Row>
              <Col lg={6} xs={6}>
                <ul>
                  <li><Link to="/about-us">About Us</Link></li>
                  {/* <li><Link to="/our-team">Our Team</Link></li> */}
                  <li><Link to="/hire-a-cab">Hire a Cab</Link></li> 
                  <li><Link to="/contact-us">Contact Us</Link></li>
                </ul>
              </Col>

              <Col lg={6} xs={6}>
                <ul>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms-conditions">Terms & Conditions</Link></li> 
                </ul>
              </Col>
            </Row>
          </Col>

          {/* Contact */}
          <Col lg={4} className="mb-4">
            <h4>Contact</h4>
            <p>{setting?.address}</p>
            <p>GSTIN: {setting?.otherone}</p>
            {setting?.emailid && (
              <p>
                <a href={`mailto:${setting.emailid}`}>
                  {setting.emailid}
                </a>
              </p>
            )}

            {setting?.mobile && (
              <p className="p-0 m-0">
                <a href={`tel:${setting.mobile}`}>
                  {setting.mobile}
                </a>
              </p>
            )}
             {setting?.whatsapp && (
              <p className="p-0 ">
                <a href={`tel:+91${setting.whatsapp}`}>
                  +91 {setting.whatsapp}
                </a>                
              </p>
            )}
             
          </Col>

          {/* Social */}
          <Col lg={3} className="mb-4">
            <h4>Follow us on</h4>
            <div className="social-icons">
              {setting?.facebook && (
                <a href={setting.facebook} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
              )}

              {setting?.youtube && (
                <a href={setting.youtube} target="_blank" rel="noreferrer">
                  <i class="fa-brands fa-google"></i>
                </a>
              )}

              {setting?.instagram && (
                <a href={setting.instagram} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              )}

              {setting?.linkedin && (
                <a href={setting.linkedin} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-linkedin-in"></i>
                </a>
              )}
             
              
            </div>
           {setting?.other && (
  <div className="mt-3">
    <a
      href={setting.other}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={tripadvisor}
        alt="TripAdvisor"
        className="img-fluid"
        style={{ maxHeight: 40 }}
      />
    </a>
  </div>
)}

          </Col>
        </Row>
      </Container>

      {/* Copyright */}
      <div className="text-center footer_b">
        Copyright © {new Date().getFullYear()} Kashi Journeys.
        All rights reserved.
      </div>

      {/* Back to top */}
      {showTopBtn && (
        <button className="back-to-top" onClick={scrollToTop}>
          <i className="bi bi-arrow-up-short"></i>
        </button>
      )}
    </div>
  );
}
